import { render, staticRenderFns } from "./dynamic-document-machine-working-area-boundary-field-template.vue?vue&type=template&id=e0349082&"
import script from "./dynamic-document-machine-working-area-boundary-field-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-machine-working-area-boundary-field-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
